/**
 * Critical translations that must be available synchronously at first render.
 * These are pre-seeded into i18next before the async HTTP backend loads,
 * preventing raw translation keys from flashing on the signup/login pages.
 *
 * Only includes keys used on signup and login forms for paid-traffic languages (en, pt).
 * The full translation bundle loaded via HTTP will merge over these.
 */

export const criticalTranslations: Record<string, { common: Record<string, unknown> }> = {
  en: {
    common: {
      signupForm: {
        formTitle: 'Sign Up for Free',
        emailLabel: 'Email',
        emailPlaceholder: 'Your Email',
        emailError: 'Email is required!',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Your Password',
        passwordError: 'Password is required!',
        signupButton: 'Sign Up',
        signingUp: 'Signing up...',
        continueWith: 'Or continue with',
        existingAccount: 'Already have an account?',
        loginLink: 'Log In',
        title: 'Sign Up',
      },
      loginForm: {
        header: 'Log In',
        emailLabel: 'Email',
        emailPlaceholder: 'Your Email',
        emailRequired: 'Email is required!',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Your Password',
        passwordRequired: 'Password is required!',
        loginButton: 'LOG IN',
        loggingIn: 'Logging in...',
        orContinueWith: 'Or continue with',
        dontHaveAccount: "I don't have an account?",
        signUp: 'Sign Up',
        forgotPassword: 'Forgot your password?',
        pageTitle: 'Login',
      },
    },
  },
  pt: {
    common: {
      signupForm: {
        formTitle: 'Inscreva-se gratuitamente',
        emailLabel: 'E-mail',
        emailPlaceholder: 'Seu email',
        emailError: 'O e-mail é obrigatório!',
        passwordLabel: 'Senha',
        passwordPlaceholder: 'Sua senha',
        passwordError: 'Senha requerida!',
        signupButton: 'Inscrever-se',
        signingUp: 'Inscrevendo-se...',
        continueWith: 'Ou continue com',
        existingAccount: 'já tem uma conta?',
        loginLink: 'Conecte-se',
        title: 'Inscrever-se',
      },
      loginForm: {
        header: 'Conecte-se',
        emailLabel: 'E-mail',
        emailPlaceholder: 'Seu email',
        emailRequired: 'O e-mail é obrigatório!',
        passwordLabel: 'Senha',
        passwordPlaceholder: 'Sua senha',
        passwordRequired: 'Senha requerida!',
        loginButton: 'CONECTE-SE',
        loggingIn: 'Entrando...',
        orContinueWith: 'Ou continue com',
        dontHaveAccount: 'Eu não tenho uma conta?',
        signUp: 'Inscrever-se',
        forgotPassword: 'Esqueceu sua senha?',
        pageTitle: 'Conecte-se',
      },
    },
  },
};
